import request from '@/utils/request'

export default {
  getSimpleSecurities(qry) {
    const query = Object.entries(qry || {}).reduce((acc, [key, value]) => {
      if (typeof value === 'string') {
        const v = value.trim()
        if (v !== '') acc[key] = v
      } else if (value !== undefined && value !== null) {
        acc[key] = value
      }
      return acc
    }, {})
    return request.get('/sm-svc/getSimpleSecurities', { params: query })
  },
  getSecurity(securityId) {
    return request.get('/sm-svc/getSecurity', { params: securityId })
  },
  getUnderlyingBbgTickers(underlyingTicker) {
    return request.get('/sm-svc/getUnderlyingBbgTickers', {
      params: underlyingTicker,
    })
  },
  getSecurityStartWith(ticker) {
    return request.get('/sm-svc/getSecurityStartWith', {
      params: ticker,
    })
  },
  createSec(securityInfo) {
    return request.post('/sm-svc/createSec', securityInfo)
  },
  updateSec(securityInfo) {
    return request.post('/sm-svc/updateSec', securityInfo)
  },
  updateIdentifiers(securityId, identifiers) {
    return request.post(`/sm-svc/updateIdentifiers/${securityId}`, identifiers)
  },

  getGicsSectors() {
    return request.get('/sm-svc/getGicsSectors')
  },

  getSectors() {
    return request.get('/sm-svc/getSectors')
  },
}
